module.exports = {"331126001":"松源街道","331126002":"濛洲街道","331126003":"屏都街道","331126101":"黄田镇","331126102":"竹口镇","331126104":"荷地镇","331126105":"左溪镇","331126106":"贤良镇","331126107":"百山祖镇","331126200":"岭头乡","331126201":"五大堡乡","331126202":"淤上乡","331126203":"安南乡","331126204":"张村乡","331126205":"隆宫乡","331126206":"举水乡","331126207":"江根乡","331126209":"龙溪乡","331126211":"官塘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331126.json
// module id = 1135
// module chunks = 0